import * as Common from "../../commons/common"

export class SumupGroup {
  id: number
  school_id: number
  exec_date: string
  name: string

  constructor(sumupGroup: any){
    this.id = sumupGroup.id;
    this.school_id = sumupGroup.school_id;
    this.exec_date = sumupGroup.exec_date;
    this.name = sumupGroup.name;
  }
}

export class RankResult {
  practice_examinee_id: number
  sheet_group_key: number
  student_no_character: string
  student_name: string
  cram_school_name: string
  cram_room_name: string
  applied_type_name: string
  applied_type: number
  isSelected: boolean = false
  score: number
  rank: number
  std_score: string
  assessment_value: string
  base64Images: string[] = []
  isDownloaded: boolean = false

  constructor(rankResult: any){
    this.practice_examinee_id = rankResult.practice_examinee_id;
    this.sheet_group_key = rankResult.sheet_group_key;
    this.student_no_character = rankResult.student_no_character;
    this.student_name = rankResult.student_name;
    this.cram_school_name = rankResult.cram_school_name;
    this.cram_room_name = rankResult.cram_room_name;
    this.applied_type_name = Common.GetAppliedTypeNameByCode(rankResult.applied_type);
    this.applied_type = rankResult.applied_type;
    this.score = rankResult.score;
    this.rank = rankResult.rank;
    this.std_score = rankResult.std_score.toFixed(1);
    this.assessment_value = rankResult.assessment_value;
  }
}

export class SumupTotalAll {
  examinee_count: number
  allot: number
  avg_score: number
  score_rate: number
 
  constructor(sumupTotalAll: any){
    this.examinee_count = sumupTotalAll.examinee_count;
    this.allot = sumupTotalAll.allot;
    this.avg_score = sumupTotalAll.avg_score.toFixed(1);
    this.score_rate = sumupTotalAll.score_rate.toFixed(1);
  }
}

export class SearchCondtion {
  student_name: string = ""
  student_no_character: string = ""
  applied_type: number = null
}